import React, { createContext, useContext, useState, useEffect } from 'react';
import { getActiveSeasonalTheme } from '../config/seasonalThemes';

const SeasonalThemeContext = createContext();

export const useSeasonalTheme = () => {
  const context = useContext(SeasonalThemeContext);
  if (!context) {
    throw new Error('useSeasonalTheme must be used within SeasonalThemeProvider');
  }
  return context;
};

export const SeasonalThemeProvider = ({ children }) => {
  const [activeTheme, setActiveTheme] = useState(null);
  const [themeEnabled, setThemeEnabled] = useState(true);

  useEffect(() => {
    // Check for active theme on mount and set up interval to check daily
    const checkActiveTheme = () => {
      const theme = getActiveSeasonalTheme();
      setActiveTheme(theme);
    };

    checkActiveTheme();

    // Check every hour in case the date changes
    const interval = setInterval(checkActiveTheme, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Allow users to toggle seasonal themes off
  const toggleTheme = () => {
    setThemeEnabled(!themeEnabled);
    localStorage.setItem('seasonalThemesEnabled', JSON.stringify(!themeEnabled));
  };

  // Load user preference
  useEffect(() => {
    const savedPreference = localStorage.getItem('seasonalThemesEnabled');
    if (savedPreference !== null) {
      setThemeEnabled(JSON.parse(savedPreference));
    }
  }, []);

  const value = {
    activeTheme: themeEnabled ? activeTheme : null,
    themeEnabled,
    toggleTheme,
  };

  return (
    <SeasonalThemeContext.Provider value={value}>
      {children}
    </SeasonalThemeContext.Provider>
  );
};
